import {destyleMktoForm, addRowClasses, addWrapClasses, populateFromHash} from './helpers/mkto.js';

/* eslint-disable no-unused-vars, no-undef */
MktoForms2.whenRendered(function(mktoForm) {
	destyleMktoForm(mktoForm);
	addRowClasses(mktoForm);
	addWrapClasses(mktoForm);
	populateFromHash(mktoForm);
});

window.dataLayer = window.dataLayer || [];

MktoForms2.whenReady(function(mktoForm) {
	let mktoId = mktoForm.getId();

	dataLayer.push({
		'event': 'marketo.loaded',
		'marketo.mktoId': mktoId
	});
	console.log( 'marketo form ' + mktoId + ' loaded.' );

	mktoForm.onSubmit(function() {
		console.log( 'marketo form ' + mktoId + ' submitted.' );
		dataLayer.push({
			'event': 'marketo.submit',
			'marketo.mktoId': mktoId
		});
	});

	mktoForm.onSuccess(function(values, followUpUrl) {
		console.log( 'marketo form ' + mktoId + ' success.' );
		dataLayer.push({
			'event': 'marketo.success',
			'marketo.mktoId': mktoId,
			'marketo.form_values': values,
			'marketo.follow_up_url': followUpUrl
		});
	});
});
/* eslint-enable no-unused-vars, no-undef */
